import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";

function Auth0ProviderWrapper({ children }) {
    return <Auth0Provider
        domain={window.authDomain}
        clientId={window.authClientId}
        redirectUri={window.location.origin}
        audience={window.authAudience}
        scope={'openid'}
    >
        {children}
    </Auth0Provider>;
}

ReactDOM.render(
  <React.StrictMode>
      <Auth0ProviderWrapper>
          <App />
      </Auth0ProviderWrapper>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
